<template>
  <div>
    <el-button type="info" size="mini" @click="getAnReply"> 查看 </el-button>
    <el-dialog
      append-to-body
      v-loading="dialogLoading"
      :title="opinionSurveyTopics.title"
      :visible.sync="dialogVisible"
      width="60%"
      style="height: 100%"
      top="1%"
      data-role="drag-drop-container"
    >
      <div style="padding: 20px; padding-bottom: 0; height: 100%">
        <el-alert
          :title="ansSurveyTopics.userName"
          type="success"
          style="margin: 5px"
          :description="`填寫時間：${ansSurveyTopics.replyDate}`"
          show-icon
          :closable="false"
        >
        </el-alert>
        <el-tag style="position: absolute; top: 0; left: 0">
          <count-to
            :start-val="0"
            :end-val="ansSurveyTopics.point"
            :duration="4600"
            class="card-panel-num"
          />/ {{ ansSurveyTopics.totalPoint }}</el-tag
        >

        <el-input placeholder="請輸入表單標題" disabled v-model="ansSurveyTopics.title">
          <template slot="prepend">表單標題</template>
        </el-input>
        <el-form :inline="false">
          <template v-for="(item, index) in ansSurveyTopics.topicList">
            <el-form-item :key="index">
              <template>
                <el-tag v-if="item.required" type="info" size="mini">必填</el-tag>
                <el-tag v-else type="info" size="mini">非必填</el-tag>
                {{ index + 1 }}，
                <span style="font-size: 12px; color: chocolate">{{
                  item.topicType == 1 ? '單選題' : '簡答題'
                }}</span>
                <el-switch
                  :disabled="item.hasAns"
                  v-if="!item.isDefault"
                  style="margin-left: 5px"
                  v-model="item.required"
                  active-text="必填"
                  inactive-text="非必填"
                >
                </el-switch>

                <el-input
                  :disabled="item.isDefault || item.hasAns"
                  size="mini"
                  v-model="item.topicDescription"
                ></el-input>
                <template v-if="item.topicType == 1">
                  <template v-if="item.topicCustomAnswer == 0">
                    <template v-for="(op, opIndex) in item.options">
                      <el-tag
                        v-if="op.isSelected"
                        style="margin: 3px; font-size: 16px; border: 1px solid blue"
                        type="success"
                        size="medium"
                        :key="opIndex"
                        >{{ op.optionDescription }}</el-tag
                      >
                      <el-tag
                        size="mini"
                        v-if="!op.isSelected"
                        style="margin: 3px"
                        type="info"
                        :key="opIndex"
                        >{{ op.optionDescription }}</el-tag
                      >
                    </template>
                  </template>
                </template>
                <template v-if="item.topicType == 2">
                  <div class="ans-text">
                    <el-input disabled :value="item.ansText"></el-input>
                  </div>
                </template>
              </template>
            </el-form-item>
          </template>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" type="danger">關 閉</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import CountTo from 'vue-count-to'

import { getTravelsOpinionSurveyReplyDetails } from '@/api/travel'
export default {
  components: {
    CountTo,
  },
  props: {
    uid: {
      type: [String, Number],
      default: '',
    },
    travelID: {
      type: [String, Number],
      default: '',
    },
    qid: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogLoading: false,
      ansSurveyTopics: {},
      opinionSurveyTopics: {},
    }
  },

  methods: {
    async getAnReply() {
      let vm = this
      const params = {
        travelID: vm.travelID,
        userIDs: [vm.uid],
        qID: vm.qid,
      }
      vm.dialogVisible = true
      vm.dialogLoading = true
      await getTravelsOpinionSurveyReplyDetails(params)
        .then(res => {
          vm.ansSurveyTopics = res.data[0]
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          vm.dialogLoading = false
        })
    },
  },
}
</script>
